<!-- mat card  -->
<mat-card appearance="outlined" class="solution" data-testid="solution-card">
  <mat-card-content style="padding: 0; margin-bottom: 16px">
    <img mat-card-image src="{{ solution.imageUrl }}" class="solution__image" alt="{{ solution.title }}" />
    <div class="solution__content">
      <mat-card-title
        class="font-size-headline4 text-dark"
        data-testid="solution-card-title"
        style="line-height: 1.3; margin-bottom: 8px"
        >{{ solution.title }}</mat-card-title
      >
      <mat-card-subtitle
        data-testid="solution-card-description"
        class="font-size-body font-weight-light text-dark"
        style="margin-bottom: 16px; line-height: 1.5"
        >{{ solution.description }}</mat-card-subtitle
      >
    </div>
  </mat-card-content>
  <mat-card-actions class="d-flex justify-content-center align-items-center" style="padding-bottom: 16px">
    <button mat-button color="primary" (click)="onLearnMore()" style="line-height: 36px; height: auto">
      {{ renderButtonText() }}
    </button>
  </mat-card-actions>
</mat-card>
